.card {
  background-color: var(--tuna-palette-background-paper);
  color: var(--tuna-palette-text-primary);
  border: 1px solid var(--tuna-palette-divider);
  border-radius: var(--tuna-shape-borderRadius);
  padding: var(--tuna-spacing-2);
  width: 280px;
  max-width: 320px;
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
}

.heading {
  margin: 0;
  font-weight: 600;
}

.body {
  color: var(--tuna-palette-text-secondary);
}

.actions {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
}

@media (max-width: 599.95px) {
  .card {
    width: calc(100vw - 16px);
    max-width: none;
  }
}
